export default "__VITE_ASSET__03ac1940__"